<style src="./OAuth.scss" lang="scss"></style>

<template lang="pug">
  .oauth
    ul.oauth__list
      li.oauth__item(
        v-for='provider in providers'
      )
        button.oauth__button(
          :class='`is-${provider}`'
          :title='provider'
          type='button'
          @click='request(provider)'
        )
</template>

<script>
import { mapActions } from "vuex";

export default {
  props: {
    providers: {
      type: Array,
      validator: value => {
        return value.every(provider => {
          return ["google", "vkontakte", "odnoklassniki", "facebook"].includes(
            provider
          );
        });
      }
    }
  },
  computed: {
    host() {
      return `${location.protocol}//${location.host}`;
    }
  },
  methods: {
    ...mapActions({
      oauthRequest: "oauth/request"
    }),
    request(provider) {
      this.oauthRequest({ provider, host: this.host });
    }
  }
};
</script>
